export default "__VITE_ASSET__53379dd8__"